import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { IngredientsServices } from '../../ingredients/services';
import { Globals } from '../../../globals';
import { ConfigurationServices } from '../../configuration/services';
import { ProductsServices } from '../../products/services';

/**
 * Generated class for the VariationsCreateFavSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-variations-create-fav-select',
  templateUrl: 'variations-create-fav-select.html',
})
export class VariationsCreateFavSelectPage {

  update_state: boolean = false;
  dish_uid: string;
  dish_name: string;
  fav_variations: any;
  origin: string;
  product_uid: string;
  product_name: string;
  dish: any;
  product: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public toastCtrl: ToastController,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public productsServices: ProductsServices) {

    this.update_state = this.navParams.get('update');
    this.origin = this.navParams.get('origin');
    this.fav_variations = this.navParams.get('fav_variations');
    //dish
    this.dish_uid = this.navParams.get('dish_uid');
    this.dish_name = this.navParams.get('dish_name');
    this.dish = this.navParams.get('dish');
    //product
    this.product_uid = this.navParams.get('product_uid');
    this.product_name = this.navParams.get('product_name');
    this.product = this.navParams.get('product');
  }

  async ionViewWillEnter() {
    this.configurationServices.getPagesVariations();

    //reniciar variable
    this.configurationServices.fav_variations_array_tmp = Array();

    if (this.update_state) {
      if (this.fav_variations != null) {
        if (this.fav_variations.length > 0) {
          this.configurationServices.fav_variations_array_tmp = Array(); //Reiniciamos array para no tener los antiguos valores.
          for (let entry of this.fav_variations) {
            //Recuperamos los valores del ingredientes a tratar
            await this.configurationServices.firestore.collection('variations').doc(entry.uid).get().then(doc => {
              var v = doc.data();
              var _array = Array();
              _array.push(entry.uid);
              _array.push(v.name);
              _array.push(v.price);
              _array.push(v.type);
              this.configurationServices.fav_variations_array_tmp.push(_array);
            });
          }
        }
      }
    } else {
      this.fav_variations = Array();
      this.configurationServices.fav_variations_array_tmp = Array();
    }
    this.configurationServices.fav_variations_array_tmp = [...this.configurationServices.fav_variations_array_tmp];
  }

  openSaveVariationsFavourites() {
    //init
    var _array = Array();
    //recorer listado fav_variations_array_tmp
    for (var i = 0; this.configurationServices.fav_variations_array_tmp.length > i; i++) {
      //crear y push de variaciones favs
      _array.push({
        uid: this.configurationServices.fav_variations_array_tmp[i][0],
        name_static: this.configurationServices.fav_variations_array_tmp[i][1],
        price_static: this.configurationServices.fav_variations_array_tmp[i][2],
        type_static: this.configurationServices.fav_variations_array_tmp[i][3],
        updated_at: new Date(),
      });
    }
    //miramos si es plato o producto y editamos en firestore
    if (this.origin === 'dish') {//caso plato
      this.ingredientsServices.afs.collection('dish').doc(this.dish_uid).update({
        'variations_favourite': _array,
        'updated_at': new Date(),
        'updated_user': this.globals.user_name
      }).then(() => {
        this.globals.GAtrackView('Dish', 'Dish - Variations favourite - Update', this.globals.restaurant.email, 'Create/Update', 'Update variations favourite', 'Dish', this.dish_name);
        this.configurationServices.fav_variations_array_tmp = Array();
        this.navCtrl.pop();
      });
    } else {//caso plato producto
      this.productsServices.afs.collection('products').doc(this.product_uid).update({
        'variations_favourite': _array,
        'updated_at': new Date(),
        'updated_user': this.globals.user_name
      }).then(() => {
        this.globals.GAtrackView('Products', 'Products - Variations favourite - Update', this.globals.restaurant.email, 'Create/Update', 'Update variations favourite', 'Products', this.product_name);
        this.configurationServices.fav_variations_array_tmp = Array();
        this.navCtrl.pop();
      });
    }
  }

  searchVariationsNode(value) {
    this.configurationServices.searchVariationsNode(value);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/variations/variations-create-fav-select/variations-create-fav-select.ts